export function hasAnyPage(category) {
  return category?.Sections?.some((section) =>
    section?.Features?.some((feature) => feature?.IsPage),
  );
}

export function sectionHasAnyPage(section) {
  return section?.Features?.some((feature) => feature?.IsPage);
}

export function getSectionTitle(description) {
  const value = String(description || "").trim();
  if (!value) return "";
  if (value.toLowerCase() === "cash") return "Cash Payment";
  return value;
}

export function getCategoryKey(category) {
  return category?.CategoryID ?? category?.Description ?? "";
}

export function isOverviewCategory(category) {
  return String(category?.Description || "").trim().toUpperCase() === "OVERVIEW";
}

export function isBslCategory(category) {
  return (
    String(category?.Description || "").trim().toUpperCase() ===
    "BSL BANK ACCOUNT"
  );
}

export function getPageFeatures(section) {
  return (Array.isArray(section?.Features) ? section.Features : []).filter(
    (feature) => feature?.IsPage,
  );
}
